import React from "react"
import RichText from "./richText"
import Buttons from "./buttons"
import Figure from "./figure"
import Section from "../components/section"

import styles from "./imageTextSectionCourses.module.scss"

const ImageTextSectionCourses = props => (
  <Section
    theme={props.backgroundColor}
    bg={props.backgroundColor === "course-" ? "" : "dark"}
  >
    <div className={`grid ${styles.scroll}`} id={props.reference.slug.current}>
      <div className="gridItem">
        <div
          className={`${styles.imageTextSection} ${styles[props.imgPosition]}`}
        >
          <div className={styles.content}>
            <RichText blocks={props.text} />
            {props.cta && <Buttons buttons={props.cta.button} />}
          </div>
          <div
            className={`${styles.image} ${props.overlap ? styles.overlap : ""}`}
          >
            <Figure {...props.image} />
          </div>
        </div>
      </div>
    </div>
  </Section>
)

export default ImageTextSectionCourses
